'use strict';

var Json_decode = require("@glennsl/bs-json/lib/js/src/Json_decode.js");

function updateResponse(json) {
  return {
          TAG: /* Ok */0,
          _0: {
            status: Json_decode.field("status", Json_decode.$$int, json)
          }
        };
}

var Decode = {
  updateResponse: updateResponse
};

exports.Decode = Decode;
/* No side effect */
